export const AMENITIES_LOADING = 'AMENITIES_LOADING';
export const AMENITIES_SUCCESS = 'AMENITIES_SUCCESS';
export const AMENITIES_FAILURE = 'AMENITIES_FAILURE';
